document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.block-section-title, h2, h3').forEach(function(heading) {
    if (!heading.id && heading.textContent.trim()) {
      const id = heading.textContent.trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
      heading.id = id;
      heading.style.scrollMarginTop = '135px';
    }
  });
});